<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import BFeedbackPage from '@/components/base/BFeedbackPage/BFeedbackPage.vue'
import type { FeedbackState } from '@/components/base/BFeedbackPage/types'
import type { PaymentFeedback } from './types'

// Feedback window of the payment dialog (ADA-4432 etapp 8), on the shared BFeedbackPage.
//
// D13: the payment has four outcomes but the shared base has three states. `canceled` maps onto
// the failed state with its OWN wording — a payment the payer cancelled is not an error, but it
// is not a success either, and giving it a green tick would be a lie. `pending` got a real third
// state on the base component, since an awaiting-settlement payment is neither.
const { feedback, isPublic } = defineProps<{
  feedback: PaymentFeedback | null
  /** Logged out there is no debt list to return to — the dialog just closes. */
  isPublic: boolean
}>()

const emit = defineEmits<{ close: [] }>()

const { t } = useI18n()

const state = computed<FeedbackState | null>(() => {
  if (feedback == null) return null
  if (feedback === 'paid') return 'success'
  return feedback === 'pending' ? 'pending' : 'failed'
})

const title = computed(() => (feedback != null ? t(`common.payment_${feedback}_title`) : ''))
const text = computed(() => (feedback != null ? t(`common.payment_${feedback}_text`) : ''))
const buttonText = computed(() => (isPublic ? t('common.close') : t('common.return_to_debts')))
</script>

<template>
  <b-feedback-page
    :feedback="state"
    :title="title"
    :button-text="buttonText"
    @close="emit('close')"
  >
    {{ text }}
  </b-feedback-page>
</template>
